// 'https://rajapinnat.ymparisto.fi/api/Hakemistorajapinta/1.0/odata/Kunta'
// manually edited to needed format
// ATTENTION! IF SOMETHING IS CHANGED HERE, CHANGES MUST ALSO BE APPLIED TO app/Constants/Municipalities.php
export const municipalities = [
    { value: 5, label: 'Alajärvi', regionId: 14 },
    { value: 9, label: 'Alavieska', regionId: 17 },
    { value: 10, label: 'Alavus', regionId: 14 },
    { value: 16, label: 'Asikkala', regionId: 7 },
    { value: 18, label: 'Askola', regionId: 1 },
    { value: 19, label: 'Aura', regionId: 2 },
    { value: 20, label: 'Akaa', regionId: 6 },
    { value: 35, label: 'Brändö', regionId: 21 },
    { value: 43, label: 'Eckerö', regionId: 21 },
    { value: 46, label: 'Enonkoski', regionId: 10 },
    { value: 47, label: 'Enontekiö', regionId: 19 },
    { value: 49, label: 'Espoo', regionId: 1 },
    { value: 50, label: 'Eura', regionId: 4 },
    { value: 51, label: 'Eurajoki', regionId: 4 },
    { value: 52, label: 'Evijärvi', regionId: 14 },
    { value: 60, label: 'Finström', regionId: 21 },
    { value: 61, label: 'Forssa', regionId: 5 },
    { value: 62, label: 'Föglö', regionId: 21 },
    { value: 65, label: 'Geta', regionId: 21 },
    { value: 69, label: 'Haapajärvi', regionId: 17 },
    { value: 71, label: 'Haapavesi', regionId: 17 },
    { value: 72, label: 'Hailuoto', regionId: 17 },
    { value: 74, label: 'Halsua', regionId: 16 },
    { value: 75, label: 'Hamina', regionId: 8 },
    { value: 76, label: 'Hammarland', regionId: 21 },
    { value: 77, label: 'Hankasalmi', regionId: 13 },
    { value: 78, label: 'Hanko', regionId: 1 },
    { value: 79, label: 'Harjavalta', regionId: 4 },
    { value: 81, label: 'Hartola', regionId: 7 },
    { value: 82, label: 'Hattula', regionId: 5 },
    { value: 86, label: 'Hausjärvi', regionId: 5 },
    { value: 90, label: 'Heinävesi', regionId: 12 },
    { value: 91, label: 'Helsinki', regionId: 1 },
    { value: 92, label: 'Vantaa', regionId: 1 },
    { value: 97, label: 'Hirvensalmi', regionId: 10 },
    { value: 98, label: 'Hollola', regionId: 7 },
    { value: 102, label: 'Huittinen', regionId: 4 },
    { value: 103, label: 'Humppila', regionId: 5 },
    { value: 105, label: 'Hyrynsalmi', regionId: 18 },
    { value: 106, label: 'Hyvinkää', regionId: 1 },
    { value: 108, label: 'Hämeenkyrö', regionId: 6 },
    { value: 109, label: 'Hämeenlinna', regionId: 5 },
    { value: 111, label: 'Heinola', regionId: 7 },
    { value: 139, label: 'Ii', regionId: 17 },
    { value: 140, label: 'Iisalmi', regionId: 11 },
    { value: 142, label: 'Iitti', regionId: 7 },
    { value: 143, label: 'Ikaalinen', regionId: 6 },
    { value: 145, label: 'Ilmajoki', regionId: 14 },
    { value: 146, label: 'Ilomantsi', regionId: 12 },
    { value: 148, label: 'Inari', regionId: 19 },
    { value: 149, label: 'Inkoo', regionId: 1 },
    { value: 151, label: 'Isojoki', regionId: 14 },
    { value: 152, label: 'Isokyrö', regionId: 14 },
    { value: 153, label: 'Imatra', regionId: 9 },
    { value: 165, label: 'Janakkala', regionId: 5 },
    { value: 167, label: 'Joensuu', regionId: 12 },
    { value: 169, label: 'Jokioinen', regionId: 5 },
    { value: 170, label: 'Jomala', regionId: 21 },
    { value: 171, label: 'Joroinen', regionId: 11 },
    { value: 172, label: 'Joutsa', regionId: 13 },
    { value: 176, label: 'Juuka', regionId: 12 },
    { value: 177, label: 'Juupajoki', regionId: 6 },
    { value: 178, label: 'Juva', regionId: 10 },
    { value: 179, label: 'Jyväskylä', regionId: 13 },
    { value: 181, label: 'Jämijärvi', regionId: 4 },
    { value: 182, label: 'Jämsä', regionId: 13 },
    { value: 186, label: 'Järvenpää', regionId: 1 },
    { value: 202, label: 'Kaarina', regionId: 2 },
    { value: 204, label: 'Kaavi', regionId: 11 },
    { value: 205, label: 'Kajaani', regionId: 18 },
    { value: 208, label: 'Kalajoki', regionId: 17 },
    { value: 211, label: 'Kangasala', regionId: 6 },
    { value: 213, label: 'Kangasniemi', regionId: 10 },
    { value: 214, label: 'Kankaanpää', regionId: 4 },
    { value: 216, label: 'Kannonkoski', regionId: 13 },
    { value: 217, label: 'Kannus', regionId: 16 },
    { value: 218, label: 'Karijoki', regionId: 14 },
    { value: 224, label: 'Karkkila', regionId: 1 },
    { value: 226, label: 'Karstula', regionId: 13 },
    { value: 230, label: 'Karvia', regionId: 4 },
    { value: 231, label: 'Kaskinen', regionId: 15 },
    { value: 232, label: 'Kauhajoki', regionId: 14 },
    { value: 233, label: 'Kauhava', regionId: 14 },
    { value: 235, label: 'Kauniainen', regionId: 1 },
    { value: 236, label: 'Kaustinen', regionId: 16 },
    { value: 239, label: 'Keitele', regionId: 11 },
    { value: 240, label: 'Kemi', regionId: 19 },
    { value: 241, label: 'Keminmaa', regionId: 19 },
    { value: 244, label: 'Kempele', regionId: 17 },
    { value: 245, label: 'Kerava', regionId: 1 },
    { value: 249, label: 'Keuruu', regionId: 13 },
    { value: 250, label: 'Kihniö', regionId: 6 },
    { value: 256, label: 'Kinnula', regionId: 13 },
    { value: 257, label: 'Kirkkonummi', regionId: 1 },
    { value: 260, label: 'Kitee', regionId: 12 },
    { value: 261, label: 'Kittilä', regionId: 19 },
    { value: 263, label: 'Kiuruvesi', regionId: 11 },
    { value: 265, label: 'Kivijärvi', regionId: 13 },
    { value: 271, label: 'Kokemäki', regionId: 4 },
    { value: 272, label: 'Kokkola', regionId: 16 },
    { value: 273, label: 'Kolari', regionId: 19 },
    { value: 275, label: 'Konnevesi', regionId: 13 },
    { value: 276, label: 'Kontiolahti', regionId: 12 },
    { value: 280, label: 'Korsnäs', regionId: 15 },
    { value: 284, label: 'Koski Tl', regionId: 2 },
    { value: 285, label: 'Kotka', regionId: 8 },
    { value: 286, label: 'Kouvola', regionId: 8 },
    { value: 287, label: 'Kristiinankaupunki', regionId: 15 },
    { value: 288, label: 'Kruunupyy', regionId: 15 },
    { value: 290, label: 'Kuhmo', regionId: 18 },
    { value: 291, label: 'Kuhmoinen', regionId: 6 },
    { value: 295, label: 'Kumlinge', regionId: 21 },
    { value: 297, label: 'Kuopio', regionId: 11 },
    { value: 300, label: 'Kuortane', regionId: 14 },
    { value: 301, label: 'Kurikka', regionId: 14 },
    { value: 304, label: 'Kustavi', regionId: 2 },
    { value: 305, label: 'Kuusamo', regionId: 17 },
    { value: 309, label: 'Outokumpu', regionId: 12 },
    { value: 312, label: 'Kyyjärvi', regionId: 13 },
    { value: 316, label: 'Kärkölä', regionId: 7 },
    { value: 317, label: 'Kärsämäki', regionId: 17 },
    { value: 318, label: 'Kökar', regionId: 21 },
    { value: 320, label: 'Kemijärvi', regionId: 19 },
    { value: 322, label: 'Kemiönsaari', regionId: 2 },
    { value: 398, label: 'Lahti', regionId: 7 },
    { value: 399, label: 'Laihia', regionId: 15 },
    { value: 400, label: 'Laitila', regionId: 2 },
    { value: 402, label: 'Lapinlahti', regionId: 11 },
    { value: 403, label: 'Lappajärvi', regionId: 14 },
    { value: 405, label: 'Lappeenranta', regionId: 9 },
    { value: 407, label: 'Lapinjärvi', regionId: 1 },
    { value: 408, label: 'Lapua', regionId: 14 },
    { value: 410, label: 'Laukaa', regionId: 13 },
    { value: 416, label: 'Lemi', regionId: 9 },
    { value: 417, label: 'Lemland', regionId: 21 },
    { value: 418, label: 'Lempäälä', regionId: 6 },
    { value: 420, label: 'Leppävirta', regionId: 11 },
    { value: 421, label: 'Lestijärvi', regionId: 16 },
    { value: 422, label: 'Lieksa', regionId: 12 },
    { value: 423, label: 'Lieto', regionId: 2 },
    { value: 425, label: 'Liminka', regionId: 17 },
    { value: 426, label: 'Liperi', regionId: 12 },
    { value: 430, label: 'Loimaa', regionId: 2 },
    { value: 433, label: 'Loppi', regionId: 5 },
    { value: 434, label: 'Loviisa', regionId: 1 },
    { value: 435, label: 'Luhanka', regionId: 13 },
    { value: 436, label: 'Lumijoki', regionId: 17 },
    { value: 438, label: 'Lumparland', regionId: 21 },
    { value: 440, label: 'Luoto', regionId: 15 },
    { value: 441, label: 'Luumäki', regionId: 9 },
    { value: 444, label: 'Lohja', regionId: 1 },
    { value: 445, label: 'Parainen', regionId: 2 },
    { value: 475, label: 'Maalahti', regionId: 15 },
    { value: 478, label: 'Maarianhamina', regionId: 21 },
    { value: 480, label: 'Marttila', regionId: 2 },
    { value: 481, label: 'Masku', regionId: 2 },
    { value: 483, label: 'Merijärvi', regionId: 17 },
    { value: 484, label: 'Merikarvia', regionId: 4 },
    { value: 489, label: 'Miehikkälä', regionId: 8 },
    { value: 491, label: 'Mikkeli', regionId: 10 },
    { value: 494, label: 'Muhos', regionId: 17 },
    { value: 495, label: 'Multia', regionId: 13 },
    { value: 498, label: 'Muonio', regionId: 19 },
    { value: 499, label: 'Mustasaari', regionId: 15 },
    { value: 500, label: 'Muurame', regionId: 13 },
    { value: 503, label: 'Mynämäki', regionId: 2 },
    { value: 504, label: 'Myrskylä', regionId: 1 },
    { value: 505, label: 'Mäntsälä', regionId: 1 },
    { value: 507, label: 'Mäntyharju', regionId: 10 },
    { value: 508, label: 'Mänttä-Vilppula', regionId: 6 },
    { value: 529, label: 'Naantali', regionId: 2 },
    { value: 531, label: 'Nakkila', regionId: 4 },
    { value: 535, label: 'Nivala', regionId: 17 },
    { value: 536, label: 'Nokia', regionId: 6 },
    { value: 538, label: 'Nousiainen', regionId: 2 },
    { value: 541, label: 'Nurmes', regionId: 12 },
    { value: 543, label: 'Nurmijärvi', regionId: 1 },
    { value: 545, label: 'Närpiö', regionId: 15 },
    { value: 560, label: 'Orimattila', regionId: 7 },
    { value: 561, label: 'Oripää', regionId: 2 },
    { value: 562, label: 'Orivesi', regionId: 6 },
    { value: 563, label: 'Oulainen', regionId: 17 },
    { value: 564, label: 'Oulu', regionId: 17 },
    { value: 576, label: 'Padasjoki', regionId: 7 },
    { value: 577, label: 'Paimio', regionId: 2 },
    { value: 578, label: 'Paltamo', regionId: 18 },
    { value: 580, label: 'Parikkala', regionId: 9 },
    { value: 581, label: 'Parkano', regionId: 6 },
    { value: 583, label: 'Pelkosenniemi', regionId: 19 },
    { value: 584, label: 'Perho', regionId: 16 },
    { value: 592, label: 'Petäjävesi', regionId: 13 },
    { value: 593, label: 'Pieksämäki', regionId: 10 },
    { value: 595, label: 'Pielavesi', regionId: 11 },
    { value: 598, label: 'Pietarsaari', regionId: 15 },
    { value: 599, label: 'Pedersören kunta', regionId: 15 },
    { value: 601, label: 'Pihtipudas', regionId: 13 },
    { value: 604, label: 'Pirkkala', regionId: 6 },
    { value: 607, label: 'Polvijärvi', regionId: 12 },
    { value: 608, label: 'Pomarkku', regionId: 4 },
    { value: 609, label: 'Pori', regionId: 4 },
    { value: 611, label: 'Pornainen', regionId: 1 },
    { value: 614, label: 'Posio', regionId: 19 },
    { value: 615, label: 'Pudasjärvi', regionId: 17 },
    { value: 616, label: 'Pukkila', regionId: 1 },
    { value: 619, label: 'Punkalaidun', regionId: 6 },
    { value: 620, label: 'Puolanka', regionId: 18 },
    { value: 623, label: 'Puumala', regionId: 10 },
    { value: 624, label: 'Pyhtää', regionId: 8 },
    { value: 625, label: 'Pyhäjoki', regionId: 17 },
    { value: 626, label: 'Pyhäjärvi', regionId: 17 },
    { value: 630, label: 'Pyhäntä', regionId: 17 },
    { value: 631, label: 'Pyhäranta', regionId: 2 },
    { value: 635, label: 'Pälkäne', regionId: 6 },
    { value: 636, label: 'Pöytyä', regionId: 2 },
    { value: 638, label: 'Porvoo', regionId: 1 },
    { value: 678, label: 'Raahe', regionId: 17 },
    { value: 680, label: 'Raisio', regionId: 2 },
    { value: 681, label: 'Rantasalmi', regionId: 10 },
    { value: 683, label: 'Ranua', regionId: 19 },
    { value: 684, label: 'Rauma', regionId: 4 },
    { value: 686, label: 'Rautalampi', regionId: 11 },
    { value: 687, label: 'Rautavaara', regionId: 11 },
    { value: 689, label: 'Rautjärvi', regionId: 9 },
    { value: 691, label: 'Reisjärvi', regionId: 17 },
    { value: 694, label: 'Riihimäki', regionId: 5 },
    { value: 697, label: 'Ristijärvi', regionId: 18 },
    { value: 698, label: 'Rovaniemi', regionId: 19 },
    { value: 700, label: 'Ruokolahti', regionId: 9 },
    { value: 702, label: 'Ruovesi', regionId: 6 },
    { value: 704, label: 'Rusko', regionId: 2 },
    { value: 707, label: 'Rääkkylä', regionId: 12 },
    { value: 710, label: 'Raasepori', regionId: 1 },
    { value: 729, label: 'Saarijärvi', regionId: 13 },
    { value: 732, label: 'Salla', regionId: 19 },
    { value: 734, label: 'Salo', regionId: 2 },
    { value: 736, label: 'Saltvik', regionId: 21 },
    { value: 738, label: 'Sauvo', regionId: 2 },
    { value: 739, label: 'Savitaipale', regionId: 9 },
    { value: 740, label: 'Savonlinna', regionId: 10 },
    { value: 742, label: 'Savukoski', regionId: 19 },
    { value: 743, label: 'Seinäjoki', regionId: 14 },
    { value: 746, label: 'Sievi', regionId: 17 },
    { value: 747, label: 'Siikainen', regionId: 4 },
    { value: 748, label: 'Siikajoki', regionId: 17 },
    { value: 749, label: 'Siilinjärvi', regionId: 11 },
    { value: 751, label: 'Simo', regionId: 19 },
    { value: 753, label: 'Sipoo', regionId: 1 },
    { value: 755, label: 'Siuntio', regionId: 1 },
    { value: 758, label: 'Sodankylä', regionId: 19 },
    { value: 759, label: 'Soini', regionId: 14 },
    { value: 761, label: 'Somero', regionId: 2 },
    { value: 762, label: 'Sonkajärvi', regionId: 11 },
    { value: 765, label: 'Sotkamo', regionId: 18 },
    { value: 766, label: 'Sottunga', regionId: 21 },
    { value: 768, label: 'Sulkava', regionId: 10 },
    { value: 771, label: 'Sund', regionId: 21 },
    { value: 777, label: 'Suomussalmi', regionId: 18 },
    { value: 778, label: 'Suonenjoki', regionId: 11 },
    { value: 781, label: 'Sysmä', regionId: 7 },
    { value: 783, label: 'Säkylä', regionId: 4 },
    { value: 785, label: 'Vaala', regionId: 17 },
    { value: 790, label: 'Sastamala', regionId: 6 },
    { value: 791, label: 'Siikalatva', regionId: 17 },
    { value: 831, label: 'Taipalsaari', regionId: 9 },
    { value: 832, label: 'Taivalkoski', regionId: 17 },
    { value: 833, label: 'Taivassalo', regionId: 2 },
    { value: 834, label: 'Tammela', regionId: 5 },
    { value: 837, label: 'Tampere', regionId: 6 },
    { value: 844, label: 'Tervo', regionId: 11 },
    { value: 845, label: 'Tervola', regionId: 19 },
    { value: 846, label: 'Teuva', regionId: 14 },
    { value: 848, label: 'Tohmajärvi', regionId: 12 },
    { value: 849, label: 'Toholampi', regionId: 16 },
    { value: 850, label: 'Toivakka', regionId: 13 },
    { value: 851, label: 'Tornio', regionId: 19 },
    { value: 853, label: 'Turku', regionId: 2 },
    { value: 854, label: 'Pello', regionId: 19 },
    { value: 857, label: 'Tuusniemi', regionId: 11 },
    { value: 858, label: 'Tuusula', regionId: 1 },
    { value: 859, label: 'Tyrnävä', regionId: 17 },
    { value: 886, label: 'Ulvila', regionId: 4 },
    { value: 887, label: 'Urjala', regionId: 6 },
    { value: 889, label: 'Utajärvi', regionId: 17 },
    { value: 890, label: 'Utsjoki', regionId: 19 },
    { value: 892, label: 'Uurainen', regionId: 13 },
    { value: 893, label: 'Uusikaarlepyy', regionId: 15 },
    { value: 895, label: 'Uusikaupunki', regionId: 2 },
    { value: 905, label: 'Vaasa', regionId: 15 },
    { value: 908, label: 'Valkeakoski', regionId: 6 },
    { value: 915, label: 'Varkaus', regionId: 11 },
    { value: 918, label: 'Vehmaa', regionId: 2 },
    { value: 921, label: 'Vesanto', regionId: 11 },
    { value: 922, label: 'Vesilahti', regionId: 6 },
    { value: 924, label: 'Veteli', regionId: 16 },
    { value: 925, label: 'Vieremä', regionId: 11 },
    { value: 927, label: 'Vihti', regionId: 1 },
    { value: 931, label: 'Viitasaari', regionId: 13 },
    { value: 934, label: 'Vimpeli', regionId: 14 },
    { value: 935, label: 'Virolahti', regionId: 8 },
    { value: 936, label: 'Virrat', regionId: 6 },
    { value: 941, label: 'Vårdö', regionId: 21 },
    { value: 946, label: 'Vöyri', regionId: 15 },
    { value: 976, label: 'Ylitornio', regionId: 19 },
    { value: 977, label: 'Ylivieska', regionId: 17 },
    { value: 980, label: 'Ylöjärvi', regionId: 6 },
    { value: 981, label: 'Ypäjä', regionId: 5 },
    { value: 989, label: 'Ähtäri', regionId: 14 },
    { value: 992, label: 'Äänekoski', regionId: 13 }
];


// WEBPACK FOOTER //
// ./resources/assets/js/constants/municipalities.js